import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

const requireRead = async () => {
  const { useUserStore } = await import('src/CrudManager/Core/stores/useUserStore')
  return useUserStore().hasPermission('cm-business_partner_read') || { path: '/' }
}

/** Editing needs the right to update; without it the register is only ever shown, never opened in an editor. */
const requireUpdate = async (to: RouteLocationNormalized) => {
  const { useUserStore } = await import('src/CrudManager/Core/stores/useUserStore')
  const store = useUserStore()
  if (!store.hasPermission('cm-business_partner_read')) return { path: '/' }
  return store.hasPermission('cm-business_partner_update') || { name: 'compliance-register', params: { id: to.params.id } }
}

// Registers are identified by UUID; the constraint keeps fixed paths such as
// `/compliance-registers/template` from being taken for a register id.
const ID = ':id([0-9a-fA-F-]{36})'

export const complianceRegisterRoutes: RouteRecordRaw[] = [
  {
    path: '/compliance-registers',
    name: 'compliance-registers',
    component: () => import('./ComplianceRegistersPage.vue'),
    beforeEnter: requireRead,
    meta: { title: 'Registres de conformité', requiresAuth: true },
  },
  {
    path: '/compliance-registers/template',
    name: 'compliance-register-template',
    component: () => import('./ComplianceTemplatePage.vue'),
    beforeEnter: requireRead,
    meta: { title: 'Registre par défaut', requiresAuth: true },
  },
  {
    path: `/compliance-registers/${ID}`,
    name: 'compliance-register',
    component: () => import('./ComplianceRegisterView.vue'),
    beforeEnter: requireRead,
    meta: { title: 'Registre de conformité', requiresAuth: true },
  },
  {
    path: `/compliance-registers/${ID}/edit`,
    name: 'compliance-register-edit',
    component: () => import('./ComplianceRegisterEditor.vue'),
    beforeEnter: requireUpdate,
    meta: { title: 'Modifier le registre de conformité', requiresAuth: true },
  },
]

export default complianceRegisterRoutes
